import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  spotlight: {
    border: 0,
    padding: '3rem 30px 1rem 30px',
    margin: '1rem',
  },
}));

export default useStyles